<template>
       <div class="swiper-container">
        <ol class="breadcrumb swiper-no-swiping position-fixed"></ol>
        <!-- Additional required wrapper -->
        <div class="swiper-wrapper">
            <div class="swiper-slide overflow-auto swiper-no-swiping" data-title="4.1. Procesos de formación de la palabra">
                <div class="container-fluid margen_principal">
                    <div class="row">
                        <div class="col-xl-5 col-lg-5 col-12">
                            <h3>4.1. Procesos de formación de la palabra</h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6 col-xl-6 col-sm-12 col-md-12 col-12">
                           <p>La formación de palabras nuevas en una lengua se denomina creación de neologismos, estos se definen como el proceso por el cual una palabra nueva ingresa al idioma. Estos procesos se pueden dar el uso de préstamos lingüísticos con de otras lenguas, los procesos sociales y culturales propios de la globalización, la creación y multiplicación. Para ilustrar lo anterior, se tomará como referencia la clasificación de Antas, D. (2007).</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xl-6 col-lg-6 col-12 offset-xl-3 offset-lg-3">
                            <h6>Tabla 2<br><span class="font-italic">Procesos de formación de palabra</span></h6>
                         <div class="tabla1 mt-3 table-responsive">
                             <table class="table table-bordered">
                                 <tbody>
                                        <tr class="EncabezadoTabla">
                                            <td class="align-middle pb-0 mb-0 bordeiztabla">
                                                <h5 class="text-center">Proceso de formación</h5>
                                            </td>
                                            <td class="align-middle pb-0 mb-0">
                                                <h5 class="text-center">Unidades </h5>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="align-middle pb-0 mb-0 EncabezadoTabla">
                                                <p class="color5Ppal">Adquisición o préstamo de otra lengua</p>
                                            </td>
                                            <td class="align-middle pb-0 mb-0">
                                                <tr>
                                                    <p class="">Préstamo léxico: palabra tomada de otro idioma. Ejemplos: mail, software, mouse. </p>
                                                </tr>
                                                <tr>
                                                    <p class="">Calco semántico: se adquiere el significado, más no la palabra. Ejemplos: luna de miel (honey moon), guerra fría (cold war)</p>
                                                </tr>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="align-middle pb-0 mb-0 EncabezadoTabla">
                                                <p class="color5Ppal">Creación</p>
                                            </td>
                                            <td class="align-middle pb-0 mb-0">
                                                <tr>
                                                    <p class="">Onomatopeyas: palabras motivadas por los sonidos que tratan de reproducir o sugerir un objeto. Ejemplos: tic-tac; zig-zag; glu, glu.</p>
                                                </tr>
                                                <tr>
                                                    <p class="">Invenciones: palabra formadas por un gusto estético sin una motivación particial.</p>
                                                    <p>Ejemplo: nívola, prosías.</p>
                                                </tr>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="align-middle pb-0 mb-0 EncabezadoTabla">
                                                <p class="color5Ppal">Multiplicación </p>
                                            </td>
                                            <td class="align-middle pb-0 mb-0">
                                                <p>Creación de palabras a partir de otras instauradas en la lengua, como los acrónimos.</p>
                                                <p>Ejemplo: ONU, láser, sida.</p>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <h6>Basada en Antas, D. (2007).</h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {SwiperController} from '../assets/RecursosITM/js/Swiper'

export default {
    name: 'Tema4_4-1',
    mounted(){
        SwiperController(),
        document.title = this.$route.meta.title
    }
}
</script>